module.exports = __webpack_public_path__ + "image/1_8510a.jpeg";